import { createBrowserRouter } from "react-router-dom";
import Home from "../pages/home";
import About from "../pages/about";
import Service from "../pages/service";
import Project from "../pages/project";
import Contact from "../pages/contact";
import PageNotFound from "../pages/error-pages/PageNotFound";
import Loader from "../components/loader";
import Credits from "../components/credits";
import NewsletterForm from "../components/NewsletterForm";


const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/service",
    element: <Service />,
  },
  {
    path: "/project",
    element: <Project />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/createNewsLetter",
    element: <NewsletterForm />,
  },
  {
    path: "*",
    element: <PageNotFound />,
  },
]);

const routes = [
  {
    path: "/",
    element: <Home />,
    loader: <Loader />,
  },
  {
    path: "/home",
    element: <Home />,
    loader: <Loader />,
  },
  {
    path: "/about",
    element: <About />,
    loader: <Loader />,
  },
  {
    path: "/service",
    element: <Service />,
    loader: <Loader />,
  },
  {
    path: "/project",
    element: <Project />,
    loader: <Loader />,
  },
  {
    path: "/contact",
    element: <Contact />,
    loader: <Loader />,
  },
  {
    path: "/credits",
    element: <Credits />,
    loader: <Loader />,
  },
  {
    path: "/createNewsLetter",
    element: <NewsletterForm />,
  },
  {
    path: "*",
    element: <PageNotFound />,
    loader: <Loader />,
  },
];
export { router, routes };
